// Mirrors frontend/mobile/src/utility/checkInDate.ts.
/**
 * The booked check-in as the cover words it ("Monday 9 November"), or `null`
 * when there is nothing to announce: no date, an unparseable one, or one that
 * has already passed.
 */
export const formatCheckInDate = (
  iso: string | null | undefined,
  locale: string,
  now: Date = new Date()
): string | null => {
  if (!iso) return null;
  const at = new Date(iso);
  if (Number.isNaN(at.getTime()) || at.getTime() <= now.getTime()) return null;
  // Formatted apart and joined: the combined format puts a comma after the
  // weekday in Safari and in some locales ("Tuesday, 10 November").
  const weekday = new Intl.DateTimeFormat(locale, { weekday: "long" }).format(
    at
  );
  const dayMonth = new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
  }).format(at);
  return `${weekday} ${dayMonth}`;
};
